module.exports = __webpack_public_path__ + "static/img/29068580.3ef66db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/29068580.jpg
// module id = dOc+
// module chunks = 0